var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2566 0H3.74312C1.67999 0 0 1.67999 0 3.74312V24.2566C0 26.3197 1.67999 27.9997 3.74312 27.9997H24.2566C26.3197 27.9997 27.9997 26.3197 27.9997 24.2566V3.74312C27.9997 1.67999 26.3197 0 24.2566 0ZM3.74312 2.0926H24.2566C25.1703 2.0926 25.9071 2.82945 25.9071 3.74312V14.6777L21.1619 8.69465C20.6019 7.95781 19.4819 7.95781 18.9219 8.69465L11.9957 17.4482L9.10728 14.2946C8.51781 13.6462 7.48625 13.6462 6.89678 14.2946L2.0926 19.5114V3.74312C2.0926 2.82945 2.82945 2.0926 3.74312 2.0926Z",
    fill: "#7157C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22093 10.3159C8.93008 10.3159 10.3156 8.93033 10.3156 7.22117C10.3156 5.51201 8.93008 4.12646 7.22093 4.12646C5.51177 4.12646 4.12622 5.51201 4.12622 7.22117C4.12622 8.93033 5.51177 10.3159 7.22093 10.3159Z",
    fill: "#7157C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f8e80d998d97c5d5a577a23fdf2c56dd.svg";
export { ForwardRef as ReactComponent };